import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";
import AudioManager from "../../Shared/AudioManager";
import Player from "../../Models/Player";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class ScoreDetails extends cc.Component {
    @property(cc.Node)
    togItem: cc.Node = null;
    @property(cc.SpriteFrame)
    sp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    sp2: cc.SpriteFrame = null;
    @property(cc.ScrollView)
    scrollV: cc.ScrollView = null;
    @property(cc.ToggleContainer)
    toCont: cc.ToggleContainer = null;
    // @property([cc.Label])
    // titleArr: cc.Label[] = [];
    // @property([cc.Toggle])
    // togArr: cc.Toggle[] = [];
    @property(cc.Node)
    content: cc.Node = null;
    @property(cc.Node)
    nodata: cc.Node = null;
    @property(cc.Label)
    totalBet: cc.Label = null;
    @property(cc.Label)
    totalReturn: cc.Label = null;
    private userID: string = "";
    private stlmDate: string = ""
    //[0: {id: 1, gameTitleCn: "电竞游戏", gameTitleEn: "E-Sports Betting", iconImgOnUrl:]


    checkUpdate(){
        UIManager.showLoadingUI();
        NetworkLogic.agentGetGameCategoryAndGamePlatform({}, function (re) {
            UIManager.hideLoadingUI();
            console.log("===做二级界面GameCategory：", re);
            let category = [];
            this.toCont.node.destroyAllChildren();
            //this.node.destroyAllChildren();
            for (let i = 0; i < re.length; i++) {
                // if (i === 0) {
                //     category.push({ gameTitleCn: i18n.t('BasicsJS.Sports_eSports'), id: 1 })
                // }
                // else if (i === 1) {
                //     continue;
                // }
                // else {
                category.push({ gameTitleCn: re[i].gameTitleCn, id: i + 1 })
                //}
            }
            for (let i = 0; i < category.length; i++) {
                let togItem = cc.instantiate(this.togItem);
                togItem.parent = this.toCont.node;
                togItem.getChildByName("lab0").getComponent(cc.Label).string = category[i].gameTitleCn;
                togItem.getComponent(cc.Toggle).checkEvents[0].customEventData = category[i].id;
                togItem.active = true;
            }
            let toggle0 = this.toCont.toggleItems[0];
            toggle0.check();
            toggle0.checkEvents[0].emit([toggle0.checkEvents[0].customEventData]);
            this.scrollV.scrollToLeft();
        }.bind(this), function (err) {
            console.log("===代理错误err:", err)
        })
    }
    onEnable() {
        //this.node.on("SCOREDETAIL", this.updataUI.bind(this));

    }

    /**
     * 0:
     gameType: ""
     soubUserId: "testnana5007"
     relationship: 1
     brokerageRate: 0.4
     returnAllMoney: 800
     returnMoney: 0
     validBetNumber: 200000
     noSubordinateSourceMoney: 800
     * @param re
     * @param param
     */
    updataUI(returnBrokerageInfoDtos) {

        if (returnBrokerageInfoDtos.length > 0) {
            this.nodata.active = false;
            this.content.active = true;
            if (this.content.children.length > returnBrokerageInfoDtos.length) {
                for (let i = returnBrokerageInfoDtos.length; i < this.content.children.length; i++) {
                    this.content.children[i].active = false;
                }
            }
            for (let i = 0; i < returnBrokerageInfoDtos.length; i++) {
                let re = returnBrokerageInfoDtos[i];
                let item = null;
                if (i < this.content.children.length) {
                    item = this.content.children[i];
                }
                else {
                    item = cc.instantiate(this.content.children[0])
                }
                item.parent = this.content;
                item.getChildByName("bg").getComponent(cc.Sprite).spriteFrame = (i % 2 === 0 ? this.sp1 : this.sp2);
                item.getChildByName("soubUserId").getComponent(cc.Label).string = re.soubUserId;
                item.getChildByName("relationship").getComponent(cc.Label).string = (re.relationship === 1 ? i18n.t('BasicsJS.directly') : i18n.t('BasicsJS.not_directly'));
                item.getChildByName("validBetNumber").getComponent(cc.Label).string = Player.getPy("currencySymbol") + re.validBetNumber;
                let rate = re.brokerageRate + "%";
                let totalrate = rate;
                if (re.relationship > 2) {
                    for (let i = 0; i < re.relationship - 2; i++) {
                        totalrate = totalrate + "*" + rate;
                    }
                }
                item.getChildByName("brokerageRate").getComponent(cc.Label).string = totalrate;
                item.getChildByName("returnMoney").getComponent(cc.Label).string = Player.getPy("currencySymbol") + re.returnAllMoney;
                item.active = true;
            }
        }
        else {
            this.nodata.active = true;
            this.content.active = false;
        }

    }

    onTitleClick(event, param) {
        AudioManager.playSound("button");
        let data1 = {
            "gameType": param,
            "stlmDate": this.stlmDate,
            "userId": this.userID
        }

        //item 赋值
        UIManager.showLoadingUI();
        NetworkLogic.agentGameDetail(data1, 1, 9999, function (re) {
            console.log("===做二级界面item 赋值 gentGameDetail：", re);
            //总计赋值
            NetworkLogic.agentDayGameReturnInfoTotal(data1, function (re) {
                console.log("===做二级界面总计 re：", re);
                this.totalBet.string = Player.getPy("currencySymbol")  +  re.validBetNumber;
                this.totalReturn.string = Player.getPy("currencySymbol")  +   re.returnAllMoney;
                UIManager.hideLoadingUI();
            }.bind(this), function (err) {
                UIManager.hideLoadingUI();
                console.log("===代理错误err:", err)
            })
            this.updataUI(re.returnBrokerageInfoDtos);
        }.bind(this), function (err) {
            console.log("===代理错误err:", err)
        })

    }
    onBtnClose(event, param) {
        AudioManager.playSound("close");
        this.node.destroy();
    }


}
